import React from "react";
import Modal from "react-bootstrap/Modal";
import { formatNumber } from "utils/currencyFormat";

const ChiTietDongLaiTatToanPhiKhac = ({ show, onHide, data, loading, title }) => {
    const isPhiKhacList = data?.DanhSachPhiKhac && data.DanhSachPhiKhac.length > 0;
    const isTatToan = title && title.toLowerCase().includes('tất toán');
    const DetailRow = ({ label, value, colorClass = "", isBold = false, border = true }) => (
        <div className={`d-flex justify-content-between align-items-center`} style={{ fontSize: '14px', marginBottom: '10px' }}>
            <span className="color-ga" style={{ fontWeight: 500, color: '#2B335E' }}>{label}</span>
            <span className={`${colorClass} ${isBold ? 'font-weight-bold' : ''}`}>
                {formatNumber(value)}
            </span>
        </div>
    );

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            className="modal-new modal-fade"
            style={{ zIndex: 1060 }}
        >
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title color7-bold ml-1 mt-1" style={{ fontSize: '16px', fontWeight: 600 }}>
                        {title || (isPhiKhacList ? "Chi tiết phí khác" : "Chi tiết giao dịch")}
                    </h5>
                    <button type="button" className="close-popup-new" onClick={onHide} style={{ opacity: 1, padding: '1rem' }}>
                        <i className="mdi mdi-close"></i>
                    </button>
                </div>

                <div className="modal-body p-1">
                    {loading ? (
                        <div className="text-center p-4">
                            <div className="loader loader-default is-active"></div>
                        </div>
                    ) : (
                        isPhiKhacList ? (
                            <div className="Left808x200 Table-main-new" style={{ marginTop: 0, boxShadow: 'none', border: '1px solid #e3ebf3', borderRadius: '5px' }}>
                                <div className="custom-table-wrapper">
                                    <div className="table-headers" style={{ backgroundColor: '#f8f9fc', borderBottom: '1px solid #e3ebf3' }}>
                                        <div className="custom-table-header flex-basis-50" style={{ paddingLeft: '10px', justifyContent: 'flex-start', borderRight: '1px solid #e3ebf3' }}>
                                            <p>Tên phí</p>
                                        </div>
                                        <div className="custom-table-header flex-basis-50 text-right" style={{ paddingRight: '10px', justifyContent: 'flex-end' }}>
                                            <p>Số tiền</p>
                                        </div>
                                    </div>
                                    <div className="custom-table-body">
                                        {data.DanhSachPhiKhac.map((item, idx) => (
                                            <div key={idx} className="custom-table-row" style={{ minHeight: '40px', borderBottom: '1px solid #eee' }}>
                                                <div className="custom-table-cell flex-basis-50" style={{ paddingLeft: '10px', justifyContent: 'flex-start' , borderRight: '1px solid #e3ebf3'}}>
                                                    {item.TenPhi}
                                                </div>
                                                <div className="custom-table-cell flex-basis-50 text-right" style={{ paddingRight: '10px', justifyContent: 'flex-end' }}>
                                                    <span className="font-weight-bold">{formatNumber(item.SoTien)}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="detail-info-container">
                                <DetailRow label="Tiền gốc" value={data.TienGoc} colorClass="color-xanh-bold" />
                                <DetailRow label="Tiền lãi" value={data.TienLai} colorClass="color-do-bold" />
                                <DetailRow label="Phí hàng kỳ" value={data.PhiHangKy} colorClass="color7"/>
                                <DetailRow label="Phí khác" value={data.PhiKhac} colorClass="color7"/>
                                <DetailRow label="Phí kho" value={data.PhiKho} colorClass="color7"/>
                                <DetailRow label="Phạt chậm đóng lãi" value={data.PhatChamDongLai} colorClass="color7"/>
                                {isTatToan && (
                                    <DetailRow label="Phạt tất toán sớm" value={data.PhatTatToanSom} colorClass="color7"/>
                                )}
                            </div>
                        )
                    )}
                </div>

                <div className="modal-footer" >
                    <button className="btn btn-new-main btn-closenew" onClick={onHide} style={{ minWidth: '80px' }}>
                        <i className="mdi mdi-close"></i>&nbsp; Đóng
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ChiTietDongLaiTatToanPhiKhac;